// @flow

import React, { Component } from 'react';
import type { StaffType, StaffFiltersSearchType } from 'types/Staff';
import type { SeasonListType } from 'types/Seasons';
import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';

type Props = {
  staffs: StaffType[],
  slug: string,
  seasons: SeasonListType[],
  searchStaff: (searchedStaff: string) => void,
  onFilterChange: (filters: StaffFiltersSearchType, filterType: string) => void,
  initialFilters: StaffFiltersSearchType | null,
  defaultSeason: string,
};

type State = {
  competitions: Array<{id: number, name: string}>,
  postes: Array<{id: number, name: string}>,
  staffsFilters: StaffFiltersSearchType,
};

const getDropdownOptions = (props: Props, state: State) => {
  const { staffs } = props;
  const { postes: postesInState } = state;
  if (staffs && staffs.length > 0) {
    const postes: Array<Object> = [];
    staffs.forEach((staff) => {
      const isObjectPosteExists = postes.findIndex(poste => poste.name === staff.poste.name);
      if (isObjectPosteExists === -1)
      postes.push(staff.poste);
    });
    if (postes.length > postesInState.length ) {
      return { postes };
    }
  }
  return null;
};

export default class TeamStaffsFilters extends Component<Props, State> {
  props: Props;
  state: State = {
    competitions : [],
    postes : [],
    staffsFilters: {
      equipe: this.props.slug,
      season: null,
      poste: [],
      competitions: []
    },
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.staffs) {
      return getDropdownOptions(nextProps, prevState);
    }
    return null;
  }

  convertToOptions = (options: Array<Object>, reverseBool?: boolean): Array<Object> => {
    const dropdownOptions = options.sort((a,b) => {
      return a.ordre - b.ordre;
    }).map((option): Object => ({label: option.name, value: option.id}));
    return reverseBool ? dropdownOptions.reverse() : dropdownOptions;
  }

  onInputChange = (filterType: string, value: string) => {
    const { onFilterChange } = this.props;
    this.setState((prevState: State) => {
      let newState = [];
      const filters = prevState.staffsFilters[filterType];

      if (filters.includes(value)) {
        newState = filters.filter(filter => filter !== value);
      } else {
        newState = [...filters, value];
      }

      return {
        ...prevState,
        staffsFilters : {
          ...prevState.staffsFilters,
          [filterType] : newState
        },
      };
    }, () => onFilterChange(this.state.staffsFilters, filterType));
  };

  onMultiInputChange = (value: string) => {
    const { postes } = this.state;
    const isPoste = postes.filter((poste) => poste.id === value).length > 0;
    const type = isPoste ? 'poste' : 'competitions';
    return this.onInputChange(type, value);
  };

  getTitleName = () => ({
    postes : 'Tous les postes',
    competitions: 'Toutes les competitions',
  });

  convertToMultiOptions = (staffsFilters: Object) => {
    const titles = Object.keys(staffsFilters);
    const titleName = this.getTitleName();

    return titles.reduce((result, title) => {
      result.push({ label: titleName[title]});

      const filters = staffsFilters[title].map((playerFilter) => ({
        label: playerFilter.name,
        value: playerFilter.id,
      }));

      return [
        ...result,
        ...filters,
      ];
    }, []);
  };

  selectSeason = (value: string) => {
    const { onFilterChange } = this.props;
    const season = parseInt(value, 10);
    this.setState((prevState: State) => ({
      ...prevState,
      staffsFilters: {
        ...prevState.staffsFilters,
        season,
      }
    }), () => onFilterChange(this.state.staffsFilters, 'saison'));
  };

  searchStaff = (e: SyntheticInputEvent<EventTarget>) => {
    const { searchStaff } = this.props;
    searchStaff(e.target.value);
  };

  getLabelSeason = () => {
    const { seasons } = this.props;
    const seasonsStaff = seasons.filter((season) => season.staff === true);
    const { staffsFilters: { season } } = this.state;
    const prelabel = seasonsStaff.filter((saison) => saison.id === season);

    return prelabel.length === 1 ? prelabel[0].name : this.props.defaultSeason ;
  }

  componentDidMount = () => {
    const { initialFilters } = this.props;

    if (initialFilters) {
      this.setState((prevState: State) => ({
        ...prevState,
        staffsFilters: {
          ...initialFilters,
        },
      }));
    }
  };

  render() {
    const { seasons } = this.props;
    const seasonsStaff = seasons.filter((season) => season.staff === true);
    const { postes, competitions, staffsFilters } = this.state;
    return (
      <>
        <div className="row">
          <div className="col">
            <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
              <div className="row">
                <div className="col col-lg-8on9">
                  <div className="header-filter__left">
                    { seasonsStaff && seasonsStaff.length > 0 &&
                    <DropdownRadioInput
                      prelabel={'Saison '}
                      label={this.getLabelSeason()}
                      id="Saisons"
                      options={this.convertToOptions(seasonsStaff, true)}
                      inputChanged={this.selectSeason}
                      noBorder
                      maj
                      title
                      isPreLabelThin={false}
                    /> }
                    <div className='multi-dropdown'>
                      <div className='multi-dropdown__desktop'>
                        { competitions && competitions.length > 0 && 
                          <DropdownMultiInput
                            label="Toutes les compétitions"
                            id="Compétitions"
                            options={this.convertToOptions(competitions)}
                            inputChanged={(value) => this.onInputChange('competitions', value)}
                            selected={staffsFilters.competitions}
                            className={'dropdown dropdown--noBorder dropdown--checkbox'}
                          /> }
                        { postes && postes.length > 0 && 
                          <DropdownMultiInput
                            label="Tous les postes"
                            id="Postes"
                            options={this.convertToOptions(postes)}
                            inputChanged={(value) => this.onInputChange('poste', value)}
                            selected={staffsFilters.poste}
                            className={'dropdown dropdown--noBorder dropdown--checkbox'}
                        /> }
                      </div>
                      <div className='multi-dropdown__mobile'>
                        <DropdownMultiInput
                          label="Autres Filtres"
                          id="MultiDropdown"
                          options={this.convertToMultiOptions({ postes, competitions })}
                          inputChanged={(value) => this.onMultiInputChange(value)}
                          selected={[...staffsFilters.poste, ...staffsFilters.competitions]}
                          className={'dropdown dropdown--noBorder dropdown--checkbox'}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="header-filter__right">
                    <form>
                      <div className="input input--dropdown">
                        <input
                          type="search"
                          placeholder="Saisir le nom d'un membre"
                          onChange={(e) => this.searchStaff(e)}/>
                        <div className=""></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="header-filter__sep mb-4"></div>
          </div>
        </div>
      </>
    );
  }
};
